export default class totalpassStorage {
  constructor(scope = '') {
    this.prefix = 'totalpass_';
    this.scope = `${scope}_`;
  }

  static supported() {
    return typeof Storage !== 'undefined';
  }

  addRecord(key, value) {
    localStorage.setItem(`${this.prefix}${this.scope}${key}`, value);
  }

  getRecord(key) {
    return localStorage.getItem(`${this.prefix}${this.scope}${key}`);
  }

  removeRecord(key) {
    localStorage.removeItem(`${this.prefix}${this.scope}${key}`);
  }
}

export const removeStorageByScope = (prefix, scope) => {
  Object.keys(localStorage).forEach((key) => {
    if (key.includes(`${prefix}${scope}`, 0)) {
      localStorage.removeItem(key);
    }
  });
};
